"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _underscore = require("underscore");

var _Backbone = _interopRequireDefault(require("Backbone"));

var _loggers = require("customer-data-tracking/loggers");

var LegacyViewData = _interopRequireWildcard(require("./LegacyViewData"));

var _default = {
  init: function init() {
    var lastUrl;
    return _Backbone.default.history.on('route', function (router, route) {
      // split camelCase route
      var splitRoute = route.split(/(?=[A-Z])/);
      var currentUrl = route.split('?')[0];
      var whereScreen = (splitRoute[0] || '').toLowerCase();
      var whereSubscreen = (splitRoute[1] || '').toLowerCase();
      var extraProps = {};
      var trackerProps; // settings handles it's own route tracking because it's react

      if (whereScreen === 'settings') {
        return undefined;
      } // visits and prospects don't have the same routing hierarchy


      if (whereScreen === 'biden') {
        whereScreen = whereSubscreen;
        whereSubscreen = 'index';
      } else if (whereScreen === 'visited') {
        whereScreen = 'visits';
        whereSubscreen = 'index';
      } // lists* routes were renamed to segments* while splitting out
      // the segments-ui app. this preserves original usage tracking


      if (whereScreen === 'segments') {
        whereScreen = 'lists';
      }

      if (whereScreen === 'lists' || whereScreen === 'list') {
        trackerProps = {
          namespace: 'lists'
        };
      }

      if (currentUrl === lastUrl) {
        return undefined;
      } // Additional "activation" tracking when the index page is loaded


      if (whereSubscreen === 'index') {
        (0, _underscore.defer)(_loggers.CrmLogger.log, 'indexPageActivation', {
          screen: whereScreen,
          subscreen: whereSubscreen
        });
      }

      lastUrl = currentUrl;
      var actionName = "" + whereScreen + whereSubscreen;
      var viewData = LegacyViewData[actionName];

      if (!viewData) {
        return undefined;
      }

      return (0, _underscore.defer)(function () {
        return (
          /* ********** PUBLIC EVENT **********
          Public Events help teams across HubSpot automate work and customize experiences based on user actions.
          Speak with #product-insight and your PM before any shipping any changes to this event
          Applies to:
          - view-companyprofile
          - view-companiesindex
          - view-contactprofile
          - view-contactsindex
          - view-dealprofile
          - view-dealsboard
          - view-dealsindex
          - view-tasksboard
          - view-tasksindex
          - view-ticketsboard
          - view-ticketsindex
          - view-visitsindex
          */
          _loggers.CrmLogger.log(viewData.key, (0, _extends2.default)({
            screen: whereScreen,
            subscreen: whereSubscreen
          }, viewData.properties, extraProps), trackerProps)
        );
      } // ********** PUBLIC EVENT **********
      );
    });
  }
};
exports.default = _default;
module.exports = exports.default;